import { createSlice } from "@reduxjs/toolkit";
import { InitialSubQualityFormData } from "../../ConstantData/InitialData";

const subQualitySlice = createSlice({
  name: "subquality",
  initialState: {
    subQualityList: [],
    dataEdit: [],
    isError: false,
    errorData: {},
    initialData: InitialSubQualityFormData,
  },
  reducers: {
    getAllSubQuality: (state, action) => {
      state.subQualityList = action.payload;
    },
    getSubQuality: () => {},
    createSubQuality: (state, action) => {},
    getSubQualityDataEdit: (state, action) => {
      state.dataEdit = action.payload;
    },
    setErrorData: (state, action) => {
      state.errorData = action.payload.message;
      state.isError = action.payload.isError;
    },
    setInitialData: (state, action) => {
      state.initialData = { ...InitialSubQualityFormData };
    },
    updateSubQuality: (state, action) => {},
    deleteSubQuality: () => {},
  },
});

export const subQualitySliceAction = subQualitySlice.actions;
export default subQualitySlice.reducer;
